import { Steps } from 'element-ui'

const YSteps = Steps
YSteps.$depends = [Steps]
YSteps.$name = 'y-steps'
YSteps._name = 'Steps 步骤条'

export default YSteps
